define('modules/auth/modals/views/not.supported.view',[
    'jquery',
    'underscore',
    'backbone',
    'modules/base/modals/views/modal.view',
    'text!modules/auth/modals/templates/not.supported.template.html'
], function(
    $,_,Backbone,
    ModalView,
    Template
    ){
    var NotSupportedView = ModalView.extend({
        template:_.template(Template)
    });
    return NotSupportedView;
});




